export default {
  'level-1':
    {
      bgColor: '#8D7847',
      trackID: 1,
      corners: ['blank','blank','corner-1','corner-1'],
      vAlign: 'top',
      hAlign: 'mid',
      pathSegments: [
        [674, -31, 674, -31, 974, 71, 974, 315],
        [974, 315, 973, 536, 877, 606, 723, 651],
        [723, 651, 483, 721, 73, 649, 50, 416],
        [50, 416, 27, 189, 280, 126, 492, 136],
        [492, 136, 704, 147, 797, 259, 787, 359],
        [787, 359, 776, 479, 668, 540, 493, 547],
        [493, 547, 319, 553, 195, 478, 196, 386],
        [196, 386, 197, 294, 315, 268, 315, 268]
      ]
    },
  'level-2':
    {
      bgColor: '#8CA93D',
      trackID: 2,
      corners: ['blank','blank','corner-2','corner-2'],
      vAlign: 'mid',
      hAlign: 'left',
      pathSegments: [
        [-27, 149, -27, 149, 291, 107, 526, 190],
        [526, 190, 762, 273, 781, 429, 781, 462],
        [781, 462, 781, 539, 704, 656, 532, 697],
        [532, 697, 377, 734, 266, 720, 194, 690],
        [194, 690, 147, 670, 62, 602, 77, 460],
        [77, 460, 92, 319, 252, 172, 313, 140],
        [313, 140, 371, 111, 603, 17, 793, 155],
        [793, 155, 983, 293, 977, 525, 921, 621],
        [921, 621, 876, 697, 734, 759, 547, 705],
        [547, 705, 400, 663, 266, 575, 272, 451],
        [272, 451, 278, 315, 388, 235, 505, 196],
        [505, 196, 588, 169, 753, 135, 961, 186]
      ],
      layers: [
        { start: 0,end: 500,depthOrder: 1 },
        { start: 0,end: 2500,depthOrder: 0 },
        { start: 0,end: 3800,depthOrder: 3 },
        { start: 0,end: 'total',depthOrder: 2 }
      ]
    },
  'level-3':
    {
      bgColor: '#F2B888',
      trackID: 3,
      corners: ['blank','blank','blank','blank'],
      vAlign: 'mid',
      hAlign: 'right',
      pathSegments: [
        [-28, 256, -28, 256, 105, 232, 219, 188],
        [219, 188, 334, 145, 641, 23, 733, 80],
        [733, 80, 826, 137, 826, 235, 829, 338],
        [829, 338, 833, 442, 845, 576, 793, 651],
        [793, 651, 754, 707, 625, 720, 445, 659],
        [445, 659, 265, 598, 193, 568, 101, 503]

      ],
      pathSegments2: [
        [1055, 244, 1055, 244, 750, 176, 665, 143],
        [665, 143, 580, 110, 365, 40, 292, 76],
        [292, 76, 219, 112, 190, 150, 185, 357],
        [185, 357, 180, 564, 202, 639, 259, 676],
        [259, 676, 317, 714, 472, 707, 623, 652],
        [623, 652, 769, 598, 929, 498, 932, 498]

      ]
    }
};
